{
	"title": "Zajištění odpovědnosti instalací uhlíkové banky",
	"description": "Společnost Heidelberg Materials přijala důkladná opatření, aby zaručila důvěryhodnost snížení uhlíku generovaného naší cementárnou CCS. Abychom zabránili jakékoli možnosti dvojího účtování, implementovali jsme zabezpečenou virtuální uhlíkovou banku na veřejné distribuované účetní knize.",
	"traceabilityTitle": "Sledovatelnost redukce uhlíku"
}
